import { getPathPrefix } from './helpers/href'

import { css, html, LitElement } from 'lit'
import { property, customElement } from 'lit/decorators.js'

@customElement('zaptic-subreport-widget')
export class SubreportWidget extends LitElement {
    static styles = css`
        :host {
            border: 1px solid var(--grey8);
            border-radius: 0.4rem;
            display: grid;
            grid-template: 'icon info' / 5rem auto;
            height: 7rem;
            column-gap: 0.5rem;
            background-color: white;
        }

        .icon {
            grid-area: icon;
            height: 4rem;
            padding: 1.5rem;
        }

        .subreport-info {
            grid-area: info;
            display: flex;
            flex-direction: column;
            justify-content: center;
        }

        .title {
            font-weight: var(--font-weight-bold);
            font-size: 1.6rem;
            color: var(--darkGrey);
            -webkit-line-clamp: 2;
            -webkit-box-orient: vertical;
            display: -webkit-box;
            overflow: hidden;
        }

        .subject {
            font-weight: var(--font-weight-medium);
            font-size: 1.4rem;
            color: var(--grey3);
            padding-top: 0.2rem;
        }
    `

    @property({ attribute: 'report-title' })
    reportTitle: string

    @property({ attribute: 'report-subject' })
    reportSubject: string

    render() {
        const pathPrefix = getPathPrefix()
        const trSubject = window.i18n('shared:subreportWidget.subject')
        const subjectElement = this.reportSubject
            ? html` <span class="subject">${trSubject}: ${this.reportSubject}</span> `
            : html``

        return html`
            <img class="icon" src="${pathPrefix}shared/images/report.svg" />
            <div class="subreport-info">
                <span class="title" title="${this.reportTitle}">${this.reportTitle}</span>
                ${subjectElement}
            </div>
        `
    }
}
